import axios from "@/libs/api.request";
// 获取列表
export const getList = (params) => {
  return axios.request({
    url: "/shipments/updateCod",
    params,
    method: "get",
  });
};
